module.exports = require("jspdf");